import { useQueryClient } from '@lumapps/base-api/react-query';
import { RefreshPosts } from '@lumapps/posts/types';
import { invalidatePostQueries } from '@lumapps/posts/utils/invalidatePostQueries';

export function usePostListsRefresh(): () => void;
export function usePostListsRefresh(refreshOverride: RefreshPosts | undefined): RefreshPosts;
export function usePostListsRefresh(refreshOverride?: RefreshPosts) {
    const queryClient = useQueryClient();

    if (refreshOverride) {
        return refreshOverride;
    }

    const invalidatePostLists = () => {
        invalidatePostQueries(queryClient);
    };

    return invalidatePostLists;
}
